<template>
  <div class="query-result">
    <div class="search-result-tab">
      <ul class="search-re-tab-ul search-result-main-inner">
        <li class="search-re-tab-li">
          <a href="/search/index.html">产品</a>
        </li>
        <li class="search-re-tab-li">
          <a href="/search/case.html">案例</a>
        </li>
        <li class="search-re-tab-li">
          <a href="/search/course.html">课程</a>
        </li>
        <li class="search-re-tab-li">
          <a href="/search/article.html">文章</a>
        </li>
        <li class="search-re-tab-li">
          <a href="/search/service.html">帮助中心</a>
        </li>
        <li class="search-re-tab-li active">
          <a href="/domain/result?domainName=300&domainSuffixs=.com,.cn,.net"
            >找域名</a
          >
        </li>
      </ul>
    </div>
    <!-- copy search -->
    <!-- copy search -->
    <domain-search @query="query" :isFixed="isFixed">
      <div class="cart fr" v-if="cartList.length">
        <div class="header clearfix">
          <span class="title fl ml20">购物车</span>
          <a href="javascript:;" class="clearcart fr mr30" @click="clearCart"
            >清空</a
          >
        </div>
        <div class="list" v-if="cartList.length">
          <div class="item clearfix" v-for="(item, i) in cartList" :key="i">
            <p class="domain ell" :title="item.domainName + item.domainSuffix">
              {{ item.domainName }}{{ item.domainSuffix }}
            </p>
            <p class="cart-service" v-if="isBuyEnterpriseService">
              +企业服务套餐
            </p>
            <a class="del" href="javascript:;" @click="del(item)">移除</a>
          </div>
        </div>
        <div class="list tc g6 mt20" v-else>尚未选择域名</div>
        <div class="footer">
          <el-button
            :disabled="!cartList.length"
            :loading="buyButtonIsLoading"
            class="buy"
            @click="buy"
            >立即购买</el-button
          >
          <!-- <button :disabled="!cartList.length||buyButtonIsLoading" class="buy" @click="buy">立即购买</button> -->
          <div class="mt10 lh20">
            <label>
              <input
                type="checkbox"
                v-model="isBuyEnterpriseService"
                @change="buyEnterpriseService"
                class="mr10 vm"
              />
              <span>为域名购买</span>
            </label>
            <a href="#">企业服务套餐</a>
          </div>
        </div>
      </div>
    </domain-search>

    <div class="main-container">
      <div class="container clearfix">
        <div class="recommend-domain fl">
          <div class="header">
            <span>查询结果</span>
            <span>价格</span>
            <span>操作</span>
          </div>
          <domain-result-list
            :userStatus.sync="userStatus"
            v-if="recommendDomainList"
            @addCart="addCart"
            :cartList="cartList"
            :data="recommendDomainList"
            layout="domain,tag,price,morePrice,button"
          ></domain-result-list>
          <div
            style="height: 448px; z-index: 9"
            class="loading"
            v-else
            v-loading="true"
          ></div>
        </div>
        <div class="cart fr">
          <div class="header clearfix">
            <span class="title fl ml20">购物车</span>
            <a href="javascript:;" class="clearcart fr mr30" @click="clearCart"
              >清空</a
            >
          </div>
          <div class="list" v-if="cartList.length">
            <div class="item clearfix" v-for="(item, i) in cartList" :key="i">
              <p
                class="domain ell"
                :title="item.domainName + item.domainSuffix"
              >
                {{ item.domainName }}{{ item.domainSuffix }}
              </p>
              <p class="cart-service" v-if="isBuyEnterpriseService">
                +企业服务套餐
              </p>
              <a class="del" href="javascript:;" @click="del(item)">移除</a>
            </div>
          </div>
          <div class="list tc g6 mt20" v-else>尚未选择域名</div>
          <div class="footer">
            <el-button
              :disabled="!cartList.length"
              :loading="buyButtonIsLoading"
              class="buy"
              @click="buy"
              >立即购买</el-button
            >
            <!-- <button :disabled="!cartList.length||buyButtonIsLoading" class="buy" @click="buy">立即购买</button> -->
            <div class="mt10 lh20">
              <label>
                <input
                  type="checkbox"
                  v-model="isBuyEnterpriseService"
                  @change="buyEnterpriseService"
                  class="mr10 vm"
                />
                <span>为域名购买</span>
              </label>
              <a href="/domain/home">企业服务套餐</a>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="middle f16 mt10 mb10">
          同时注册以下多个后缀，更有利于您的品牌保护：
        </div>
      </div>
      <div class="container containeryqr clearfix">
        <div class="cn-domain fl" style="width: 100%;">
          <h3 class="yqr-tit">中文域名保护</h3>
          <domain-result-list
            :userStatus.sync="userStatus"
            v-if="zhBrandProtectedDomainList"
            @addCart="addCart"
            :cartList="cartList"
            :data="zhBrandProtectedDomainList"
            layout="domain,tag,price"
          ></domain-result-list>
          <div
            style="height: 448px; z-index: 9"
            class="loading"
            v-else
            v-loading="true"
          ></div>
        </div>
        <!-- <div class="more-domain fr">
          <div class="suffix clearfix">
            <el-checkbox-group
              v-model="selectedSuffixIds"
              @change="changeSuffix"
              :disabled="suffixIsDisabled"
            >
              <el-checkbox
                v-for="(item, i) in domainSuffixList"
                :label="item.domainSuffix"
                :key="i"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
          <domain-result-list
            :userStatus.sync="userStatus"
            v-if="domainList"
            @addCart="addCart"
            :cartList="cartList"
            :data="domainList"
            layout="domain,tag,price,button"
          ></domain-result-list>
          <div
            style="height: 340px; z-index: 9"
            class="loading"
            v-else
            v-loading="true"
          ></div>
          <div class="tc p20">
            <el-button
              class="view-more"
              v-if="domainList && domainList.length < domainSuffixList.length"
              :loading="suffixIsDisabled"
              @click="getMoreDomain(5)"
              >查看更多后缀</el-button
            >
          </div>
        </div> -->
      </div>
      <recommend class="mt20"></recommend>
    </div>
  </div>
</template>
<script>
import domainResultList from "./components/domian-result-list";
import recommend from "./components/recommend";
import domainSearch from "./components/domain-search";
import prohibitionsWordList from "../static/assets/prohibitionsWordList";
function unique(arr) {
  var res = [arr[0]];
  for (var i = 1; i < arr.length; i++) {
    var repeat = false;
    for (var j = 0; j < res.length; j++) {
      if (arr[i].domainSuffix === res[j].domainSuffix) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      res.push(arr[i]);
    }
  }
  return res;
}
function getSuffix(o) {
  try {
    return o.goodsSheetModel.businessId.substr(
      o.goodsSheetModel.businessId.indexOf(".")
    );
  } catch (error) {}
}

// import { recommendDomain } from './assets/data.js'

export default {
  components: {
    recommend,
    domainResultList,
    domainSearch
  },
  data() {
    return {
      isFixed: false,
      userStatus: "unknown",
      domainName: this.$route.query.domainName,
      domainSuffixs: this.$route.query.domainSuffixs,
      isBuyEnterpriseService: this.getLocalCartList().isBuyEnterpriseService,
      cartList: this.getLocalCartList().cartList,
      buyButtonIsLoading: false,
      recommendDomainList: null,
      zhBrandProtectedDomainList: null,
      domainList: null,

      domainSuffixList: [],
      selectedSuffixIds: [],
      suffixIsDisabled: true,
      wordFlag: false
    };
  },
  computed: {
    language() {
      return /[\u4e00-\u9fa5]/g.test(this.domainName) ? "zh-CN" : "en";
    }
  },
  methods: {
    throwError(message) {
      this.$msgbox({
        type: "error",
        message
      });
    },
    getUserStatus(data) {
      if (
        data &&
        Object.keys(data)
          .sort()
          .join() === "data,msg,status"
      ) {
        return (this.userStatus = data.status === 501 ? "offline" : "unknown");
      }
      return (this.userStatus = "online");
    },
    query(domain) {
      const { domainName, domainSuffix } = domain;
      const domainSuffixs = domainSuffix || this.$route.query.domainSuffixs;

      this.$router.push({
        query: {
          domainName,
          domainSuffixs
        }
      });

      window.location.reload();
    },

    getLocalCartList() {
      return {
        cartList: JSON.parse(window.localStorage.cartList || "[]"),
        isBuyEnterpriseService: JSON.parse(
          window.localStorage.isBuyEnterpriseService || "false"
        )
      };
    },
    cacheLocalCartList() {
      window.localStorage.cartList = JSON.stringify(this.cartList);
      window.localStorage.isBuyEnterpriseService = JSON.stringify(
        this.isBuyEnterpriseService
      );
    },
    clearLocalCartList() {
      window.localStorage.clear();
    },
    syncCartList() {
      const localCartList = this.getLocalCartList();
      $.post(`${__shopURL}/dcarts/syndomaincarts`, {
        data: JSON.stringify(localCartList.cartList),
        serviceType4Domain: ~~localCartList.isBuyEnterpriseService
      }).then(response => {
        if (this.getUserStatus(response) === "offline") {
          return;
        }

        this.clearLocalCartList();
        this.getCartList();
      });
    },
    buy() {
      const data = JSON.stringify(this.cartList);
      const serviceType4Domain = ~~this.isBuyEnterpriseService;
      this.buyButtonIsLoading = true;
      $.get(`${__shopURL}/cart/checkLogin`).then(
        response => {
          this.buyButtonIsLoading = false;
          this.$router.push({
            path: "/domain/register"
          });
        },
        err => {
          this.buyButtonIsLoading = false;
        }
      );
    },
    buyEnterpriseService() {
      if (this.userStatus === "offline") {
        this.cacheLocalCartList();
        return;
      }

      $.get(
        `${__shopURL}/dcarts/updatecartinfo?serviceType4Domain=${~~this
          .isBuyEnterpriseService}`
      ).then(response => {
        if (this.getUserStatus(response) === "unknown") {
          this.throwError("服务器异常,请稍后再试！");
          this.isBuyEnterpriseService = !this.isBuyEnterpriseService;
        }
      });
    },
    clearCart() {
      this.$confirm(`是否清空购物车?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.userStatus === "offline") {
          this.clearCartLocal();
          return;
        }

        $.get(`${__shopURL}/dcarts/clearcarts`).then(
          response => {
            if (this.getUserStatus(response) === "unknown") {
              this.throwError("清空购物车遇到问题，请稍后再试");
              return;
            }
            this.clearCartLocal();
          },
          err => {
            this.throwError("清空购物车遇到问题，请稍后再试");
          }
        );
      });
    },

    clearCartLocal() {
      this.cartList = [];
      this.cacheLocalCartList();
    },
    del(item) {
      this.$confirm(
        `是否从购物车中删除域名 ${item.domainName}${item.domainSuffix}?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          if (this.userStatus === "offline") {
            this.delLocal(item);
            return;
          }

          $.get(
            `${__shopURL}/dcarts/deletecartgroup?cartGroupId=${item.id}`
          ).then(
            response => {
              if (this.getUserStatus(response) === "unknown") {
                this.throwError(
                  `从购物车中删除域名 ${item.domainName}${item.domainSuffix}失败！`
                );
                return;
              }
              this.delLocal(item);
            },
            err => {
              this.throwError(
                `从购物车中删除域名 ${item.domainName}${item.domainSuffix}失败！`
              );
            }
          );
        })
        .catch(() => {});
    },
    delLocal(item) {
      for (let i = 0; i < this.cartList.length; i++) {
        if (
          this.cartList[i].domainName === item.domainName &&
          this.cartList[i].domainSuffix === item.domainSuffix
        ) {
          this.cartList.splice(i, 1);
          this.cacheLocalCartList();
          return;
        }
      }
    },
    getCartList() {
      if (this.userStatus === "offline") {
        this.cartList = this.getLocalCartList().cartList;
        return;
      }
      $.get(`${__shopURL}/dcarts/domaincartslist`).then(
        response => {
          if (this.getUserStatus(response) === "unknown") {
            throwError("购物车列表获取失败！");
            return;
          }

          this.cartList =
            (response.cartInfoVO &&
              response.cartInfoVO.cartGroupVOList.map(v => {
                return {
                  id: v.id,
                  domainName: v.cartGroupDetailVOList[0].domainName,
                  domainSuffix: v.cartGroupDetailVOList[0].domainSuffix
                };
              })) ||
            [];
        },
        error => {
          throwError("购物车列表获取失败！");
        }
      );
    },
    getRecommendDomain() {
      $.get(
        encodeURI(
          `${__shopURL}/domain/recommendDomainList1?domainName=${this.domainName.toLowerCase()}`
        )
      ).then(response => {
        this.recommendDomainList = response.domainList;
      });
    },
    getZHBrandProtectedDomainList() {
      $.get(
        encodeURI(
          `${__shopURL}/domain/zhBrandProtectedDomainList1?domainName=${this.domainName.toLowerCase()}`
        ),
        null,
        () => {},
        "text"
      )
        .then(response => {
          this.zhBrandProtectedDomainList = response.domainList;
        })
        .fail(function(value) {
          console.log(value);
        });
    },
    addCart(item) {
      this.cartList.push(item);
      this.cacheLocalCartList();
    },
    getDomainSuffixList() {
      $.get(`${__shopURL}/domain/findDomainGoodsList`).then(response => {
        const tempDomainSuffixList = [];
        response.domainGoodsVoList &&
          response.domainGoodsVoList.forEach(v => {
            try {
              const domainObj = v.attrVoList.filter(
                c => c.goodsAttribute.attrubuteCode === "DOMAIN_SUFFIX"
              )[0];

              const languageObj = v.attrVoList.filter(
                c => c.goodsAttribute.attrubuteCode === "LANGUAGE"
              )[0];

              const language =
                languageObj && languageObj.attrValueList[0].goodsAttributeValue;

              const domainSuffixs = domainObj && domainObj.attrValueList;
              if (domainSuffixs) {
                domainSuffixs.forEach(c => {
                  c = c.goodsAttributeValue;
                  if (this.domainSuffixs.split(",").filter(v => v === c)[0]) {
                    if (this.selectedSuffixIds.indexOf(c) === -1) {
                      this.selectedSuffixIds.push(c);
                    }
                  }

                  if (this.language === language) {
                    tempDomainSuffixList.push({
                      id: v.id,
                      language,
                      domainSuffix: c,
                      goodsName: v.goodsName
                    });
                  }
                });
              }
            } catch (error) {
              console.error(error);
            }
          });

        this.domainSuffixList = unique(tempDomainSuffixList);
        this.getMoreDomain(10);
      });
    },
    sortSuffix() {
      this.suffixIsDisabled = false;
      const domainSuffixs = this.domainSuffixList.map(v => v.domainSuffix);
      this.domainList = this.domainList.sort((a, b) => {
        const suffixA = getSuffix(a);
        const suffixB = getSuffix(b);

        return (
          (~this.selectedSuffixIds.indexOf(suffixA) ? 0 : 999) +
          domainSuffixs.indexOf(suffixA) -
          ((~this.selectedSuffixIds.indexOf(suffixB) ? 0 : 999) +
            domainSuffixs.indexOf(suffixB))
        );
      });
    },
    changeSuffix(suffixs) {
      const domainListSuffixs = this.domainList.map(v => getSuffix(v));
      const arr = [];

      suffixs.forEach(v => {
        if (domainListSuffixs.indexOf(v) === -1) {
          arr.push(v);
        }
      });

      if (arr.length) {
        this.getMoreDomain(arr);
      } else {
        this.sortSuffix();
      }
    },
    getMoreDomainQueryParams(num) {
      const domainSuffixs = this.domainSuffixList.map(v => v.domainSuffix);
      const arr = [];
      for (let i = 0; i < domainSuffixs.length; i++) {
        const dx = domainSuffixs[i];
        const isExist =
          this.domainList &&
          this.domainList.filter(v => getSuffix(v) === dx)[0];
        if (this.selectedSuffixIds.indexOf(dx) === -1 && !isExist) {
          arr.push(domainSuffixs[i]);
          if (arr.length === num) {
            return arr;
          }
        }
      }
      return arr;
    },
    getMoreDomain(num) {
      const domainSuffixs = this.domainSuffixList.map(v => v.domainSuffix);
      const params = [];

      if (!this.domainList || !this.domainList.length) {
        params.push.apply(params, this.selectedSuffixIds);
        if (params.length < num) {
          params.push.apply(
            params,
            this.getMoreDomainQueryParams(num - params.length)
          );
        }
      } else {
        if (isNaN(+num)) {
          params.push.apply(params, num);
        } else {
          params.push.apply(params, this.getMoreDomainQueryParams(num));
        }
      }

      this.suffixIsDisabled = true;

      $.get(
        encodeURI(
          `${__shopURL}/domain/findDomainList1?domainName=${
            this.domainName.toLowerCase()
          }&domainSuffixes=${params.join()}`
        )
      ).then(response => {
        if (!Array.isArray(this.domainList)) {
          this.domainList = [];
        }
        this.domainList.push.apply(this.domainList, response.domainList);

        this.sortSuffix();
      });
    }
  },
  created() {
    // 违禁词
    prohibitionsWordList.map(v => {
      if (this.domainName.indexOf(v) !== -1) {
        this.wordFlag = true;
      }
    });
    if (this.wordFlag) {
      this.$msgbox({
        type: "error",
        message: "该域名限制注册！"
      });
      return;
    } else {
      this.getRecommendDomain();
      this.getZHBrandProtectedDomainList();
      this.getDomainSuffixList();
      this.syncCartList();
    }
  },
  mounted() {
    let top = $(".domain-search").offset().top;
    if (top === 0) top = 1;
    $(document).on("scroll", () => {
      const scrollTop = $(document).scrollTop();
      if (scrollTop > top && !this.isFixed) {
        this.isFixed = true;
      }
      if (scrollTop < top && this.isFixed) {
        this.isFixed = false;
      }
    });
  }
};
</script>

<style lang="scss">
@import "../static/css/query-result.scss";
</style>



// WEBPACK FOOTER //
// src/query-result.vue